export default function FacebookIcon({ currentColor = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_1273_25064)">
        <path
          d="M24.001 12.199C24.001 5.53002 18.628 0.124023 12.001 0.124023C5.371 0.125523 -0.0019989 5.53002 -0.0019989 12.2005C-0.0019989 18.226 4.387 23.221 10.123 24.127V15.6895H7.078V12.2005H10.126V9.53802C10.126 6.51252 11.9185 4.84152 14.659 4.84152C15.973 4.84152 17.3455 5.07702 17.3455 5.07702V8.04702H15.832C14.3425 8.04702 13.8775 8.97852 13.8775 9.93402V12.199H17.2045L16.6735 15.688H13.876V24.1255C19.612 23.2195 24.001 18.2245 24.001 12.199Z"
          fill={currentColor}
          fillOpacity="0.75"
        />
      </g>
      <defs>
        <clipPath id="clip0_1273_25064">
          <rect
            width="24"
            height="24"
            fill={currentColor}
            transform="translate(0 0.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
